// extracted by mini-css-extract-plugin
export default {"label":"s4919","groupLabel":"RCxvg","promoText":"B70MO","groupHead":"zP_oO","iconPlus":"uJ9uo","list":"RBJAc","product":"dFvKH"};